import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const CompanyStorySection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="section section-light" style={{ 
        position: 'relative', 
        overflow: 'hidden'
      }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '-5%',
        width: '350px',
        height: '350px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '-5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)', 
          gap: '4rem',
          alignItems: 'center'
        }}>
          <div className="col-span-7 md-col-span-12 fade-in">
            <span className="fade-in" style={{
              display: 'inline-block',
              padding: '0.5rem 1.5rem',
              backgroundColor: 'rgba(255, 107, 0, 0.1)',
              color: 'var(--assco-orange)',
              fontWeight: '600',
              fontSize: '0.875rem',
              borderRadius: 'var(--radius-full)',
              marginBottom: '1.25rem'
            }}>
              {language === 'fr' ? 'NOTRE HISTOIRE' : 
               language === 'ar' ? 'قصتنا' : 
               'OUR STORY'}
            </span>
            
            <h2 style={{ 
              fontSize: '2.75rem', 
              marginBottom: '1.75rem',
              position: 'relative',
              paddingBottom: '1.25rem',
              fontWeight: '700'
            }}>
              {t('about.companyStory.title')}
              <span style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '60px',
                height: '4px',
                backgroundColor: 'var(--assco-orange)',
                borderRadius: '2px'
              }}></span>
            </h2>
            
            <p className="text-gray-700" style={{ 
              fontSize: '1.25rem', 
              lineHeight: '1.8',
              marginBottom: '1.75rem',
              color: 'var(--assco-gray-700)',
              maxWidth: '90%',
              position: 'relative',
              paddingLeft: '1.5rem',
              borderLeft: '3px solid var(--assco-orange)'
            }}>
              {language === 'fr' 
                ? 'Fondée en 2025, ASSCO apporte plus de 20 ans d\'expérience combinée dans le secteur Pétrole, Gaz et Industrie, avec une spécialisation dans des marques reconnues mondialement telles que Panametrics, YOKOGAWA, EMERSON, SIEMENS, etc.'
                : language === 'ar'
                ? 'تأسست ASSCO في عام 2025، وتجلب أكثر من 20 عامًا من الخبرة المشتركة في قطاع النفط والغاز والصناعة، مع تخصص في العلامات التجارية المعترف بها عالميًا مثل Panametrics و YOKOGAWA و EMERSON و SIEMENS، إلخ.'
                : 'Founded in 2025, ASSCO brings over 20 years of combined experience in the Oil, Gas and Industry sector, with specialization in globally recognized brands such as Panametrics, YOKOGAWA, EMERSON, SIEMENS, etc.'}
            </p>
            
            <p className="text-gray-700" style={{ 
              fontSize: '1.2rem', 
              lineHeight: '1.8',
              marginBottom: '1.75rem',
              color: 'var(--assco-gray-700)'
            }}>
              {language === 'fr' 
                        ? 'Notre équipe est entièrement certifiée, garantissant que la sécurité et la qualité sont au premier plan de toutes nos opérations.'
        : language === 'ar' 
        ? 'فريقنا حاصل على شهادة بالكامل، مما يضمن أن السلامة والجودة في مقدمة جميع عملياتنا.'
        : 'Our team is fully certified, ensuring that safety and quality are at the forefront of all our operations.'}
            </p>
            
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '1rem',
              backgroundColor: 'rgba(255, 107, 0, 0.1)',
              padding: '0.75rem 1.25rem',
              borderRadius: 'var(--radius-lg)',
              marginBottom: '2rem'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '24px', height: '24px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p style={{ 
                margin: 0,
                fontSize: '1rem',
                color: 'var(--assco-gray-700)',
                fontWeight: '500'
              }}>
                {language === 'fr' 
                  ? 'Fondée avec plus de 20 ans d\'expertise combinée dans l\'industrie'
                  : language === 'ar'
                  ? 'تأسست مع أكثر من 20 عامًا من الخبرة المشتركة في الصناعة'
                  : 'Founded with over 20 years of combined industry expertise'}
              </p>
            </div>
            
            {/* Key values */}
            <div style={{ 
              marginTop: '2.5rem',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1.5rem'
            }}>
              <div className="value-card fade-in" style={{ 
                flex: '1 1 200px',
                backgroundColor: 'white',
                padding: '1.75rem',
                borderRadius: 'var(--radius-xl)',
                border: '1px solid var(--assco-gray-100)',
                transition: 'all 0.3s ease',
                animationDelay: '0.2s',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.03)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 25px rgba(0, 0, 0, 0.07)';
                e.currentTarget.style.borderColor = 'var(--assco-orange)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.03)';
                e.currentTarget.style.borderColor = 'var(--assco-gray-100)';
              }}>
                <div style={{ 
                  color: 'white',
                  marginBottom: '1.25rem',
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  backgroundColor: 'var(--assco-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 5px 15px rgba(255, 107, 0, 0.2)'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '28px', height: '28px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.75rem',
                  color: 'var(--assco-gray-900)',
                  fontWeight: '600'
                }}>
                  {language === 'fr' ? 'Excellence' : 
                   language === 'ar' ? 'التميز' : 
                   'Excellence'}
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Nous nous engageons à fournir des services de la plus haute qualité.' : 
                   language === 'ar' ? 'نحن ملتزمون بتقديم خدمات بأعلى جودة.' : 
                   'We are committed to delivering the highest quality services.'}
                </p>
              </div>
              
              <div className="value-card fade-in" style={{ 
                flex: '1 1 200px',
                backgroundColor: 'white',
                padding: '1.75rem',
                borderRadius: 'var(--radius-xl)',
                border: '1px solid var(--assco-gray-100)',
                transition: 'all 0.3s ease',
                animationDelay: '0.4s',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.03)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 25px rgba(0, 0, 0, 0.07)';
                e.currentTarget.style.borderColor = 'var(--assco-orange)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.03)';
                e.currentTarget.style.borderColor = 'var(--assco-gray-100)';
              }}>
                <div style={{ 
                  color: 'white',
                  marginBottom: '1.25rem',
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  backgroundColor: 'var(--assco-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 5px 15px rgba(255, 107, 0, 0.2)'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '28px', height: '28px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.75rem',
                  color: 'var(--assco-gray-900)',
                  fontWeight: '600'
                }}>
                  {language === 'fr' ? 'Collaboration' : 
                   language === 'ar' ? 'التعاون' : 
                   'Collaboration'}
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Nous travaillons en étroite collaboration avec nos clients et partenaires.' : 
                   language === 'ar' ? 'نعمل بشكل وثيق مع عملائنا وشركائنا.' : 
                   'We work closely with our clients and partners.'}
                </p>
              </div>
              
              <div className="value-card fade-in" style={{ 
                flex: '1 1 200px',
                backgroundColor: 'white',
                padding: '1.75rem',
                borderRadius: 'var(--radius-xl)',
                border: '1px solid var(--assco-gray-100)',
                transition: 'all 0.3s ease',
                animationDelay: '0.6s',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.03)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 15px 25px rgba(0, 0, 0, 0.07)';
                e.currentTarget.style.borderColor = 'var(--assco-orange)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.03)';
                e.currentTarget.style.borderColor = 'var(--assco-gray-100)';
              }}>
                <div style={{ 
                  color: 'white',
                  marginBottom: '1.25rem',
                  width: '50px',
                  height: '50px',
                  borderRadius: '12px',
                  backgroundColor: 'var(--assco-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 5px 15px rgba(255, 107, 0, 0.2)'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '28px', height: '28px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.75rem',
                  color: 'var(--assco-gray-900)',
                  fontWeight: '600'
                }}>
                  {language === 'fr' ? 'Innovation' : 
                   language === 'ar' ? 'الابتكار' : 
                   'Innovation'}
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Nous adoptons les dernières technologies et méthodes.' : 
                   language === 'ar' ? 'نتبنى أحدث التقنيات والأساليب.' : 
                   'We embrace the latest technologies and methodologies.'}
                </p>
              </div>
            </div>
          </div>
          
          <div className="col-span-5 md-col-span-12 fade-in" style={{ animationDelay: '0.3s' }}>
            <div style={{
              position: 'relative',
              padding: '20px',
            }}>
              {/* Background decorative element */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: '20%',
                bottom: '20%',
                backgroundColor: 'var(--assco-orange)',
                opacity: 0.08,
                borderRadius: 'var(--radius-xl)',
                transform: 'rotate(-3deg)'
              }}></div>
              
              <div className="image-container" style={{ 
                position: 'relative',
                borderRadius: 'var(--radius-xl)',
                overflow: 'hidden',
                boxShadow: '0 20px 30px rgba(0, 0, 0, 0.15)',
                height: '520px',
                zIndex: 2
              }}>
                {/* Industrial image placeholder */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: `url("/images/algeria-sensing.png")`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}></div>
                
                {/* Experience badge */}
                <div style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  width: '110px',
                  height: '110px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-orange)',
                  color: 'white',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 5px 15px rgba(255, 107, 0, 0.3)',
                  padding: '5px',
                  border: '3px solid rgba(255, 255, 255, 0.5)'
                }}>
                  <span style={{
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    lineHeight: '1'
                  }}>20+</span>
                  <span style={{
                    fontSize: '0.75rem',
                    textAlign: 'center',
                    lineHeight: '1.2',
                    marginTop: '5px'
                  }}>
                    {language === 'fr' ? 'ans d\'expérience' : 
                     language === 'ar' ? 'سنوات من الخبرة' : 
                     'years experience'}
                  </span>
                </div>
                
                {/* Overlay with company name */}
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: '2.5rem',
                  background: 'linear-gradient(transparent, rgba(0,0,0,0.85))',
                  color: 'white',
                  textAlign: 'center'
                }}>
                  <h3 style={{ 
                    fontSize: '1.75rem',
                    marginBottom: '0.75rem',
                    fontWeight: '700'
                  }}>
                    ALGERIA SENSING SOLUTIONS COMPANY
                  </h3>
                  <p style={{ fontSize: '1.1rem', opacity: 0.9 }}>
                    {language === 'fr' ? 'Excellence en instrumentation Pétrole, Gaz et Industrie' : 
                     language === 'ar' ? 'التميز في أجهزة القياس في قطاع النفط والغاز والصناعة' : 
                     'Excellence in Oil, Gas and Industry instrumentation'}
                  </p>
                </div>
              </div>
              
              {/* Pattern element */}
              <div style={{
                position: 'absolute',
                bottom: '-10px',
                right: '-10px',
                width: '120px',
                height: '120px',
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23FF6B00' fill-opacity='0.15' fill-rule='evenodd'%3E%3Ccircle cx='10' cy='10' r='5'/%3E%3Ccircle cx='40' cy='10' r='5'/%3E%3Ccircle cx='70' cy='10' r='5'/%3E%3Ccircle cx='100' cy='10' r='5'/%3E%3Ccircle cx='10' cy='40' r='5'/%3E%3Ccircle cx='40' cy='40' r='5'/%3E%3Ccircle cx='70' cy='40' r='5'/%3E%3Ccircle cx='100' cy='40' r='5'/%3E%3Ccircle cx='10' cy='70' r='5'/%3E%3Ccircle cx='40' cy='70' r='5'/%3E%3Ccircle cx='70' cy='70' r='5'/%3E%3Ccircle cx='100' cy='70' r='5'/%3E%3Ccircle cx='10' cy='100' r='5'/%3E%3Ccircle cx='40' cy='100' r='5'/%3E%3Ccircle cx='70' cy='100' r='5'/%3E%3Ccircle cx='100' cy='100' r='5'/%3E%3C/g%3E%3C/svg%3E")`,
                zIndex: 1
              }}></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStorySection;
